var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',_vm._g({staticClass:"addbtn",attrs:{"title":"添加"}},_vm.$listeners),[_c('i',{staticClass:"el-icon-plus"})])
}
var staticRenderFns = []

export { render, staticRenderFns }